// src/utils/axiosConfig.js
import axios from "axios";

// Create axios instance with base URL
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_DEV_API_URL, // Use an environment variable for base URL
  headers: {
    "Content-Type": "application/json",
  },
});

// Example: Add an interceptor to attach authorization token to requests
axiosInstance.interceptors.request.use(
  (config) => {
    const localStorageData = JSON.parse(localStorage.getItem("loginDetails"));
    const token = localStorageData.token;
    console.log(token, "token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle errors globally (e.g., logging out user on 401)
    if (error.response?.status === 401) {
      localStorage.removeItem("loginDetails");
      localStorage.removeItem("isAuthenticated");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
